import styled from "styled-components";
import { GameDetailsContainerDefaultBox } from "./game-details-container.default.box";

export const GameNumberBadgeMrGreenBox = styled(GameDetailsContainerDefaultBox)`
    min-height: 5rem;

    @media ${({ theme }) => theme.mediaQuery.xlAndAbove} {
        min-height: 8rem;
    }
`